<template>
 <div v-if="loading"  class="d-flex justify-content-center align-items-center mt-80">
   <b-spinner label="Spinning" class="text" variant="primary"></b-spinner>
 </div>
  <div class="comments" :style="{'background-image': 'url(' + require('@/assets/bgimage1.png') + ')'}" v-else>
    <div class="talk-about">
      <three-dots class="dots-mobile"/>
      <h1 class="title">Что говорят клиенты</h1>
    </div>
    <div class="carousel overflow-y-hidden">
      <b-carousel
        id="carousel-2"
        v-model="slide"
        :interval="99999999999999"
        controls
        indicators
        background="rgba(232, 244, 255, 0.1)"
        img-width="1024"
        img-height="480"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <b-carousel-slide
          caption=""
          background="none"
          v-for="(item, id) in getComments"
          :key="id"
        >
          <img :src="[item.gender === 'male' ? require('@/assets/male.png') : require('@/assets/female.png')]" alt="" class="comment-photo">
          <p class="comment-name">{{item.name}}</p>
          <p class="comment-text">{{item.text}}</p>
        </b-carousel-slide>
      </b-carousel>
    </div>
  </div>
</template>

<script>
  import ThreeDots from '@/components/icons/ThreeDots';
  import {mapMutations, mapGetters, mapActions} from 'vuex'
  export default {
    name: "Comments",
    components: { ThreeDots },
    data() {
      return {
        slide: 0,
        sliding: null,
        loading: true
      }
    },
    computed: {
      ...mapGetters('comments', ['getComments'])
    },
    async mounted() {
      this.loading = true
      const response = await this.fetchComments()
      this.setComments(response)
      this.loading = false
    },
    filters: {
      truncate: function (value, limit) {
        if (value.length > limit) {
          value = value.substring(0, (limit - 3)) + '...';
        }
        return value
      },
    },
    methods: {
      ...mapActions('comments', ['fetchComments']),
      ...mapMutations('comments', ['setComments']),
      onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      }
    }
  }
</script>

<style lang="scss">
  .overflow-y-hidden {
    overflow-x: hidden;
    padding-top: 40px;
    padding-bottom: 60px;
  }
  #carousel-2 {
    max-width: 632px;
    border-radius: 9px;
    background-color: rgba(232, 244, 255, 0.1) !important;
    text-shadow: unset !important;
    font-family: 'Raleway', sans-serif;
    .carousel-control-prev-icon {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='15' fill='none' viewBox='0 0 11 17'%3E%3Cpath fill='%23fff' d='M9.945 8.37l-7.12-7.12c-.165-.165-.385-.256-.62-.256-.234 0-.454.09-.618.256l-.525.524c-.34.341-.34.897 0 1.238l5.98 5.979-5.986 5.985c-.165.165-.256.385-.256.619 0 .234.091.454.256.62l.524.523c.165.165.385.256.62.256.233 0 .453-.09.618-.256l7.127-7.126c.165-.166.255-.386.255-.621 0-.236-.09-.456-.255-.621z'/%3E%3C/svg%3E%0A");
      transform: rotate(-180deg);
    }
    .carousel-control-next-icon {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='15' fill='none' viewBox='0 0 11 17'%3E%3Cpath fill='%23fff' d='M9.945 8.37l-7.12-7.12c-.165-.165-.385-.256-.62-.256-.234 0-.454.09-.618.256l-.525.524c-.34.341-.34.897 0 1.238l5.98 5.979-5.986 5.985c-.165.165-.256.385-.256.619 0 .234.091.454.256.62l.524.523c.165.165.385.256.62.256.233 0 .453-.09.618-.256l7.127-7.126c.165-.166.255-.386.255-.621 0-.236-.09-.456-.255-.621z'/%3E%3C/svg%3E%0A");
    }
    .carousel-item {
      background: unset;
    }
    .img-fluid.w-100.d-block {
      display: none !important;
    }
    .carousel-caption {
      padding: 32px;
      position: unset;
    }
    .carousel-inner {
      overflow: unset;
    }
    .comment-photo {
      position: absolute;
      width: 80px;
      height: 80px;
      top: -40px;
      left: 50%;
      margin-left: -40px;
    }
    .comment-name {
      margin-top: 32px;
      margin-bottom: 16px;
      font-size: 17px;
      font-weight: 600;
      color: #ffffff;
    }
    .comment-text {
      font-size: 14px;
      line-height: 1.56;
      text-align: left;
      color: #ffffff;
    }
    .carousel-indicators {
      bottom: -60px;
    }
    .carousel-indicators li {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      opacity: 1;
      margin-right: 8px;
      border: solid 1px #7e7e7e;
    }
    .carousel-indicators li:last-child {
      margin-right: 0;
    }
    .carousel-control-prev, .carousel-control-next {
      width: 5% !important;
    }
    .carousel-indicators .active {
      background: #5ec8f5;
      width: 10px;
      height: 10px;
      border: none;
    }
  }
  .comments {
    background-position: center;
    padding: 45px;
    background-size: cover;
    min-height: 580px;
    margin-top: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    .talk-about {
      margin-right: 79px;
      .title {
        color: #fff;
        text-align: left;
        margin-bottom: 24px;
        max-width: 289px;
      }
      .button {
        display: block;
        color: #fff;
        width: 181px;
        height: 48px;
        border-radius: 9px;
        background-color: #5ec8f5;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 17px;
        font-weight: 600;
        line-height: 1;
        color: #ffffff;
        svg {
          margin-left: 15px;
          transform: rotate(-90deg);
        }
      }
    }
    .button2 {
      display: none;
    }
  }

  @media screen and (max-width: 830px){
    .comments {
      flex-wrap: wrap;
      padding: 42px 24px 32px;
      .talk-about {
        margin-right: 0;
        max-width: unset;
        width: auto;
        .dots-mobile {
          margin-left: auto;
          margin-right: auto;
          display: block;
        }
        .title {
          max-width: unset;
          text-align: center;
        }
        .button {
          display: none;
        }
      }
      #carousel-2 {
        margin-top: 32px;
        .carousel-caption {
          padding: 24px;
        }
      }
    }
    .button2 {
      display: block;
      color: #fff;
      width: 181px;
      height: 48px;
      border-radius: 9px;
      background-color: #5ec8f5;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 17px;
      font-weight: 600;
      line-height: 1;
      color: #ffffff;
      margin-top: 100px;
      margin-left: auto;
      margin-right: auto;
      svg {
        margin-left: 15px;
        transform: rotate(-90deg);
      }
    }
  }
  @media screen and (max-width: 414px){
    .comments {
      padding: 42px 16px 0;
      #carousel-2 {
        margin-top: 32px;
        .carousel-control-prev {
          left: 5px;
        }
        .carousel-control-next {
          right: 5px;
        }
        .carousel-caption {
          padding: 28px;
        }
      }
    }
  }
</style>